module.exports = __webpack_public_path__ + "static/media/Canceled.svg";